import React, { useState } from "react";
import { Button, IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

export const PasswordChange = ({ changePassword = () => { }, showMessage }) => {
  const [state, setState] = useState({
    password: "",
    passwordConfirmation: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);

  return (
    <>
      <h2 className="inter inter-bold login-form-title">
        {window.sys_app_translate("Password is Expired", "en")}
      </h2>
      <label style={{ marginTop: "25.3px", color: "#707070" }}>
        {window.sys_app_translate("Password", "en")}
      </label>
      <div style={{ position: "relative" }}>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control inter inter-semi-bold"
          value={state.password}
          onChange={(e) => {
            setState({ ...state, password: e.target.value });
          }}
          style={{ paddingRight: "40px" }}
        />
        <IconButton
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            height: "100%",
            padding: "0 10px",
          }}
          onClick={() => setShowPassword((show) => !show)}
          tabIndex={-1}
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </div>
      <label style={{ marginTop: "25.3px", color: "#707070" }}>
        {window.sys_app_translate("Password Confirmation", "en")}
      </label>
      <div style={{ position: "relative" }}>
        <input
          type={showPasswordConfirmation ? "text" : "password"}
          className="form-control inter inter-semi-bold"
          value={state.passwordConfirmation}
          onChange={(e) => {
            setState({ ...state, passwordConfirmation: e.target.value });
          }}
          style={{ paddingRight: "40px" }}
        />
        <IconButton
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            height: "100%",
            padding: "0 10px",
          }}
          onClick={() => setShowPasswordConfirmation((show) => !show)}
          tabIndex={-1}
        >
          {showPasswordConfirmation ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </div>
      <Button
        variant="contained"
        className="login-button inter inter-bold"
        type="submit"
        onClick={(e) => {
          e.preventDefault();
          if (state.password !== state.passwordConfirmation) {
            showMessage({
              type: "warning",
              message: window.sys_app_translate("Passwords do not match", "en"),
              title: window.sys_app_translate("Warning", "en"),
            });
            return;
          }
          changePassword(state.password);
        }}
      >
        {window.sys_app_translate("Change Password", "en")}
      </Button>
    </>
  );
};